import { engageApptentiveEvent } from "../apptentiveUtils";

// when a user selects on Races Starting Soon
export const selectStartsSoonRace = () =>
  engageApptentiveEvent("Races Starting Soon is tapped");

// when a user selects on Today's Popular Races
export const selectPopularRace = () =>
  engageApptentiveEvent("Today's Popular Races is tapped");
